module.exports = __webpack_public_path__ + "resources/img/img_security_secuwayssl_vvpn.44811fec2b9d96bc62bb4a695fdaa7b7.png";